import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ProjectService } from '../../api/services/project.services';
import { ToastrService } from 'ngx-toastr';
import { CutCableTableComponent } from './cut-cable-table/cut-cable-table.component';
import { CableCut } from '../../api/models/cable-cut';

@Component({
  selector: 'app-cut-cable-modal',
  templateUrl: './cut-cable-modal.component.html',
  styleUrls: ['./cut-cable-modal.component.scss']
})

export class CutCableModalComponent implements OnInit {

  @Input() bomId: string;
  @Input() bomLineId: string;
  checkFormValidFlag: boolean;

  constructor(
    private projectService: ProjectService,
    public activeModal: NgbActiveModal
  ) { }

  cutsForm: FormGroup;
  cutsFormArray: FormArray;
  cableCutList: CableCut[];

  confirmCuts: boolean;
  @ViewChild(CutCableTableComponent) child: CutCableTableComponent;

  ngOnInit() {
    this.projectService.GetCableCuts(this.bomId, this.bomLineId).subscribe(cableCutList => {
      this.cableCutList = cableCutList;
      this.confirmCuts = cableCutList.length ? cableCutList.every(cut => cut.confirmed) : false;
    });
  }

  save() {
    this.child.addAndDeleteCableCuts(this.confirmCuts);
  }

  checkFormValid(formValid: boolean) {
    this.checkFormValidFlag = formValid;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/cut-cable-modal/cut-cable-modal.component.ts